import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import {
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaDirections,
} from "react-icons/fa";
import { GiMedicalPack } from "react-icons/gi";
import {
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";

import tambaramskin from "../../../../assets/images/tambaramskinicon.png";
import tambaramhair from "../../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "../../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "../../../../assets/images/tambarambanner4.png";

import img1 from "../../../../assets/images/autoscroll1.jpg";
import img2 from "../../../../assets/images/autoscroll2.jpg";
import img3 from "../../../../assets/images/autoscroll3.jpg";
import img4 from "../../../../assets/images/autoscroll4.jpg";
import img5 from "../../../../assets/images/autoscroll5.jpg";
import img6 from "../../../../assets/images/autoscroll6.jpg";
import img7 from "../../../../assets/images/autoscroll7.jpg";
import img8 from "../../../../assets/images/autoscroll8.jpg";
import img9 from "../../../../assets/images/autoscroll9.jpg";
import img10 from "../../../../assets/images/autoscroll10.jpg";
import img11 from "../../../../assets/images/autoscrollskin1.png";
import img12 from "../../../../assets/images/autoscrollskin2.png";
import img13 from "../../../../assets/images/autoscrollskin3.png";
import img14 from "../../../../assets/images/autoscrollskin4.png";
import img15 from "../../../../assets/images/autoscrollskin5.png";
import img16 from "../../../../assets/images/autoscrollskin6.png";
import img17 from "../../../../assets/images/autoscrollskin7.png";
import img18 from "../../../../assets/images/autoscrollskin8.png";
import img19 from "../../../../assets/images/autoscrollskin9.png";
import img20 from "../../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "../../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "../../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "../../../../assets/images/chennaitambaramhomeopathy.png";
import chennaitambaramskin1 from "../../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "../../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambarampcos from "../../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "../../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "../../../../assets/images/chennaitambarammentalhealth.jpg";

import chennaivalasaravakkamhair from "../../../../assets/images/chennaivalasaravakkamhair1.jpg";
import chennaivalasaravakkamhair1 from "../../../../assets/images/chennaivalasaravakkamhair2.jpg";
import chennaivalasaravakkamhair2 from "../../../../assets/images/chennaivalasaravakkamhair3.jpg";
import chennaivalasaravakkamhair3 from "../../../../assets/images/chennaivalasaravakkamhair4.jpg";
import chennaivalasaravakkamdental1 from "../../../../assets/images/chennaivalasaravakkamdental1.jpg";
import chennaivalasaravakkamdental2 from "../../../../assets/images/chennaivalasaravakkamdental4.jpg";
import chennaivalasaravakkamdental3 from "../../../../assets/images/chennaivalasaravakkamdental5.jpg";

import hcuraHeroVideo from "../../../../assets/video/hcura-hero2.mp4";
import hcuraHeroVideo1 from "../../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "../../../../assets/video/hcura-hero4.mp4";

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const Gachibowli = () => {
  const [activeLocation, setActiveLocation] = useState("gachibowli");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  const [valasaravakamchennaiBaModalOpen, setTambaramBaModalOpen] = useState(false);
  const [valasaravakamchennaiBaModalItems, setTambaramBaModalItems] = useState([]);
  const [valasaravakamchennaiBaModalStartIndex, setTambaramBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (valasaravakamchennaiBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft =
          valasaravakamchennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [valasaravakamchennaiBaModalOpen, valasaravakamchennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  useEffect(() => {
    document.title = "H-Cura | Leading Hair, Skin, Dental & Homeopathy Clinic in Gachibowli, Hyderabad";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Experience advanced hair, skin, dental, and homeopathy care at H-Cura Gachibowli. Our Hyderabad Multispeciality clinic offers expert clinical solutions in the heart of HITECH City."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "H-Cura Multispeciality Clinic Gachibowli, Hyderabad Homeopathy, Hair restoration Gachibowli, Advanced Dermatology Hyderabad, Digital Dentistry HITECH City, PCOS Homeopathy Hyderabad, Best clinic Vinayak Nagar Gachibowli"
      );
    }
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-gachibowli/");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-gachibowli/");
      document.head.appendChild(canonicalLink);
    }
  }, []);

  useEffect(() => {
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
    });
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    gachibowli: {
      name: "GACHIBOWLI",
      address: "H-CURA MULTISPECIALITY CLINIC, Flat no G-4, D.No 2-37/33T036/MM/G-4, Maurya Marvel Building, Vinayak Nagar, Gachibowli, Hyderabad, Telangana, 500032.",
      phone: "+91 91879 15409",
      hours: "Mon - Sun: 10:00 AM - 08:00 PM",
      nearbyAreas: "Vinayak Nagar, HITECH City, Kondapur, Madhapur, Manikonda",
      popularServices: [
        "Advanced Hair Follicular Therapy",
        "Clinical Aesthetic Dermatology",
        "Digital Cosmetic Dentistry",
        "Constitutional Homeopathic Wellness",
      ],
      specialties: "Hair, Skin, Dental & Homeopathy",
      mapUrl: "https://maps.app.goo.gl/KRTBL3HjtjwVFtr2A?g_st=aw",
      video: hcuraHeroVideo1,
    }
  };

  const advancedServices = [
    {
      id: "hair",
      title: "Pioneering Trichology & Scalp Restoration Protocols",
      subtitle: "Innovative Clinical Science for Hair Density.",
      description:
        "At H-Cura Gachibowli, we provide advanced trichological interventions to address hair loss and scalp health. Our specialized therapies, including GFC, PRP, and EXOSOMES treatments, are engineered to stimulate growth factors and restore follicular health using the latest clinical advancements in Hyderabad.",
      image: chennaitambarm,
      treatments: [
        {
          name: "Growth Factor Concentrate (GFC)",
          description: "A precision-based, acellular therapy delivering highly concentrated growth factors directly to follicles for rapid restoration.",
          icon: "gfc-icon",
          image: chennaivalasaravakkamhair1,
          benefits: ["High potency", "Accelerated growth", "Zero downtime", "Clinically proven"],
        },
        {
          name: "Platelet-Rich Plasma (PRP)",
          description: "Utilizing your body's natural regenerative properties to strengthen hair roots and improve overall scalp density.",
          icon: "prp-icon",
          image: chennaivalasaravakkamhair,
          benefits: ["Natural healing", "Improved thickness", "Safe procedure", "Sustained results"],
        },
        {
          name: "Laser Hair Stimulation",
          description: "Low-level laser therapeutics designed to increase blood flow to the scalp and energize dormant hair follicles.",
          icon: "laser-therapy-icon",
          image: chennaivalasaravakkamhair2,
          benefits: ["Non-invasive", "Follicular energy", "Safe for all", "Enhanced circulation"],
        },
      ],
      testimonial: {
        quote: "The hair restoration results I achieved at the Gachibowli clinic were beyond my expectations. The GFC treatment is truly revolutionary.",
        author: "Kiran V.",
        location: "HITECH City",
      },
    },
    {
      id: "skin",
      title: "Advanced Aesthetic Dermatology & Skin Rejuvenation",
      subtitle: "Medical-Grade Solutions for Flawless Complexion.",
      description:
        "Our Gachibowli dermatology center offers specialized care for a wide range of skin concerns. From medical treatments for acne and hyper-pigmentation to aesthetic procedures like HydraFacials and Chemical peels, we ensure your skin receives expert attention in a clinical setting.",
      image: chennaitambarmskin,
      treatments: [
        {
          name: "Signature HydraFacial",
          description: "A comprehensive medical-grade facial that detoxifies, rejuvenates, and protects your skin through advanced vortex technology.",
          icon: "hydrafacial-icon",
          image: chennaitambaramskin1,
          benefits: ["Instant glow", "Deep cleansing", "Texture refinement", "Hydration boost"],
        },
        {
          name: "Advanced Laser Resurfacing",
          description: "Precision laser therapy to address acne scars, fine lines, and uneven skin tone with minimal recovery time.",
          icon: "pigmentation-icon",
          image: chennaitambaramskin2,
          benefits: ["Scar reduction", "Even skin tone", "Collagen boost", "Safe technology"],
        },
        {
          name: "Medical Chemical Peels",
          description: "Scientifically formulated peels to treat deep-seated pigmentation and restore skin radiance under specialist supervision.",
          icon: "antiaging-icon",
          image: chennaivalasaravakkamhair3,
          benefits: ["Deep exfoliation", "Pigment control", "Clearer skin", "Expert application"],
        },
      ],
      testimonial: {
        quote: "Best skin clinic in Gachibowli. My pigmentation has cleared up remarkably after the laser sessions here.",
        author: "Sowmya R.",
        location: "Kondapur",
      },
    },
    {
      id: "dental",
      title: "Next-Gen Digital Dentistry & Smile Reconstruction",
      subtitle: "Precision Dental Care for a Perfect Smile.",
      description:
        "H-Cura Gachibowli integrates digital imaging and precision engineering to provide world-class dental care. From invisible aligners to pain-free root canals, we focus on preserving your oral health while enhancing your smile's aesthetic appeal.",
      image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      treatments: [
        {
          name: "Invisible Aligners",
          description: "Transform your smile discreetly with custom-made clear aligners designed for maximum comfort and efficiency.",
          icon: "aligner-icon",
          image: chennaivalasaravakkamdental1,
          benefits: ["Removable", "Virtually invisible", "Predictable results", "Comfortable fit"],
        },
        {
          name: "Pain-Free Root Canal",
          description: "Advanced endodontic procedures using rotary technology to ensure a swift and comfortable treatment experience.",
          icon: "rootcanal-icon",
          image: chennaivalasaravakkamdental2,
          benefits: ["Quick recovery", "High precision", "Tooth saving", "Minimal discomfort"],
        },
        {
          name: "Professional Whitening",
          description: "Medical-grade teeth whitening systems that deliver a brighter, more confident smile in a single clinical visit.",
          icon: "smile-icon",
          image: chennaivalasaravakkamdental3,
          benefits: ["Instant results", "Safe enamel care", "Long-lasting", "Shade matching"],
        },
      ],
      testimonial: {
        quote: "The digital dental setup at Gachibowli is impressive. My aligner treatment was smooth and the results are fantastic.",
        author: "Rahul M.",
        location: "Madhapur",
      },
    },
    {
      id: "homeopathy",
      title: "Constitutional Homeopathy & Holistic Therapeutics",
      subtitle: "Healing from Within with Clinical Precision.",
      description:
        "Our Gachibowli facility specializes in evidence-based homeopathy for chronic lifestyle disorders. We address the root cause of conditions like PCOS, Thyroid disease, and allergic disorders through personalized, side-effect-free medicine.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "PCOS & Hormonal Care",
          description: "Specialized homeopathic protocols to regulate cycles and treat the underlying causes of hormonal imbalances naturally.",
          icon: "hormonal-icon",
          image: chennaitambarampcos,
          benefits: ["Natural balance", "No side effects", "Holistic health", "Root-cause focus"],
        },
        {
          name: "Chronic Allergy Management",
          description: "Long-term solutions for respiratory and skin allergies by strengthening the body's immune response naturally.",
          icon: "chronic-icon",
          image: chennaitambaramchronic,
          benefits: ["Immune support", "Sustainable relief", "Safe for children", "Personalized care"],
        },
        {
          name: "Stress & Anxiety Therapy",
          description: "Gentle homeopathic interventions designed to improve mental well-being and manage stress-related physiological issues.",
          icon: "constitutional-icon",
          image: chennaitambarammentalhealth,
          benefits: ["Mental clarity", "Better sleep", "Calming effect", "Safe & natural"],
        },
      ],
      testimonial: {
        quote: "I found lasting relief for my chronic allergies through homeopathy at H-Cura Gachibowli. Highly recommended for holistic care.",
        author: "Manohar P.",
        location: "Manikonda",
      },
    },
  ];

  const testimonials = [
    {
      name: "Kiran V.",
      location: "HITECH City",
      text: "The hair restoration results I achieved at the Gachibowli clinic were beyond my expectations. The GFC treatment is truly revolutionary.",
      rating: 5,
      service: "Hair Restoration",
    },
    {
      name: "Sowmya R.",
      location: "Kondapur",
      text: "Best skin clinic in Gachibowli. My pigmentation has cleared up remarkably after the laser sessions here.",
      rating: 5,
      service: "Dermatology",
    },
    {
      name: "Rahul M.",
      location: "Madhapur",
      text: "The digital dental setup at Gachibowli is impressive. My aligner treatment was smooth and the results are fantastic.",
      rating: 5,
      service: "Dental Care",
    },
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "HITECH City Proximity",
      description: "Conveniently located in Gachibowli, providing easy access to premium healthcare for the IT and corporate hub of Hyderabad.",
      highlight: "Heart of Gachibowli",
    },
    {
      icon: <FaUserMd />,
      title: "Expert Clinical Team",
      description: "Our center is staffed by highly qualified specialists in Dermatology, Trichology, Cosmetic Dentistry, and Homeopathy.",
      highlight: "Specialist Led",
    },
    {
      icon: <GiMedicalPack />,
      title: "Modern Infrastructure",
      description: "Equipped with state-of-the-art medical technology to provide precision diagnostics and advanced clinical treatments.",
      highlight: "Tech-Forward",
    },
    {
      icon: <FaHeartbeat />,
      title: "Integrated Healthcare",
      description: "A unique Multispeciality model that combines clinical medical science with holistic homeopathic healing.",
      highlight: "Complete Wellness",
    },
    {
      icon: <FaAward />,
      title: "Quality Benchmarks",
      description: "We adhere to strict clinical protocols and maintain high standards of patient care and ethical medical practices.",
      highlight: "Gold Standards",
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personalized Care",
      description: "Every treatment plan is custom-designed based on a detailed medical assessment and individual patient requirements.",
      highlight: "Tailored Plans",
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Hygiene & Safety",
      description: "Rigorous sterilization and sanitation protocols to ensure a safe and hygienic environment for all medical procedures.",
      highlight: "Safe Environment",
    },
    {
      icon: <MdSupportAgent />,
      title: "Patient Support",
      description: "Dedicated clinical support and follow-up care to ensure the long-term success of your treatments.",
      highlight: "Post-Care Focus",
    },
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair": return "/advanced-grow-hair-treatment";
      case "skin": return "/advanced-hydrafacial-treatment";
      case "dental": return "/dental-treatment";
      case "homeopathy": return "/homeopathy-best-treatments/";
      default: return "/services";
    }
  };

  const servicesBackgroundUrl = "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

  const serviceIconMap = {
    hair: { url: tambaramhair, bgColor: "rgba(255,154,158,0.12)", borderColor: "rgba(255,154,158,0.18)", color: "#ff4d6d" },
    skin: { url: tambaramskin, bgColor: "rgba(255,223,121,0.12)", borderColor: "rgba(255,223,121,0.18)", color: "#ffb400" },
    dental: { url: "https://img.icons8.com/fluency/48/000000/tooth.png", bgColor: "rgba(144,238,144,0.12)", borderColor: "rgba(144,238,144,0.18)", color: "#28a745" },
    homeopathy: { url: tambaramleaf, bgColor: "rgba(135,206,250,0.12)", borderColor: "rgba(135,206,250,0.18)", color: "#0099cc" },
  };

  const treatmentIconMap = {
    "prp-icon": { url: "https://img.icons8.com/fluency/48/000000/syringe.png", bgColor: "rgba(255,140,140,0.06)", borderColor: "rgba(255,140,140,0.12)" },
    "gfc-icon": { url: "https://img.icons8.com/fluency/48/000000/biotech.png", bgColor: "rgba(170,200,255,0.06)", borderColor: "rgba(110,160,255,0.12)" },
    "hydrafacial-icon": { url: "https://img.icons8.com/fluency/48/000000/spa-care.png", bgColor: "rgba(200,255,230,0.06)", borderColor: "rgba(60,200,120,0.12)" },
    "antiaging-icon": { url: "https://img.icons8.com/fluency/48/000000/collagen.png", bgColor: "rgba(220,245,255,0.06)", borderColor: "rgba(80,200,240,0.12)" },
    "pigmentation-icon": { url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png", bgColor: "rgba(250,210,255,0.06)", borderColor: "rgba(220,120,240,0.12)" },
    "aligner-icon": { url: "https://img.icons8.com/fluency/48/000000/braces.png", bgColor: "rgba(230,230,255,0.06)", borderColor: "rgba(140,120,240,0.12)" },
    "smile-icon": { url: "https://img.icons8.com/fluency/48/000000/happy-tooth.png", bgColor: "rgba(200,255,220,0.06)", borderColor: "rgba(80,200,120,0.12)" },
    "rootcanal-icon": { url: "https://img.icons8.com/fluency/48/000000/tooth-cleaning.png", bgColor: "rgba(255,240,200,0.06)", borderColor: "rgba(240,180,60,0.12)" },
    "hormonal-icon": { url: "https://img.icons8.com/fluency/48/000000/hormone.png", bgColor: "rgba(255,230,240,0.06)", borderColor: "rgba(240,160,200,0.12)" },
    "chronic-icon": { url: "https://img.icons8.com/fluency/48/000000/medical-pack.png", bgColor: "rgba(230,255,240,0.06)", borderColor: "rgba(160,240,200,0.12)" },
    "constitutional-icon": { url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png", borderColor: "rgba(160,160,240,0.12)" },
  };

    const SAMPLE_GALLERY = {
    hair: [
      { id: "hair-1", combined: img1, testimonial: { quote: "My hair density improved significantly after just 3 months of GFC.", author: "Rajesh K." } },
      { id: "hair-2", combined: img2, testimonial: { quote: "The thinning on my crown area is now completely resolved.", author: "Amit S." } },
      { id: "hair-3", combined: img3, testimonial: { quote: "Scientific hair care that actually works. Very happy with the results.", author: "Priya M." } },
      { id: "hair-4", combined: img4, testimonial: { quote: "GFC and QR678 treatment gave me natural hair regrowth.", author: "Karthik R." } },
      { id: "hair-5", combined: img5, testimonial: { quote: "Professional trichology care. My hair fall has stopped completely.", author: "Deepak V." } },
      { id: "hair-6", combined: img6, testimonial: { quote: "In just 3 months, I could see more hair on my head.", author: "Anitha L." } },
      { id: "hair-7", combined: img7, testimonial: { quote: "From almost bald to full head of hair. Thank you!", author: "Suresh K." } },
      { id: "hair-8", combined: img8, testimonial: { quote: "The best hair restoration center in Gachibowli.", author: "Vikram P." } },
      { id: "hair-9", combined: img9, testimonial: { quote: "My thin hair became thick again.", author: "Ramesh B." } },
      { id: "hair-10", combined: img10, testimonial: { quote: "Excellence in every session. Highly recommended.", author: "Mahesh T." } },
    ],
    skin: [
      { id: "skin-1", combined: img11, testimonial: { quote: "The laser treatment for my acne scars was life-changing.", author: "Sneha R." } },
      { id: "skin-2", combined: img12, testimonial: { quote: "HydraFacial at H-Cura is the best for instant radiance.", author: "Kavya M." } },
      { id: "skin-3", combined: img13, testimonial: { quote: "Visible reduction in fine lines. Very professional service.", author: "Meera K." } },
      { id: "skin-4", combined: img14, testimonial: { quote: "The pigmentation on my cheeks has faded away completely.", author: "Preethi S." } },
      { id: "skin-5", combined: img15, testimonial: { quote: "Clearer and healthier skin thanks to Dr. Shravanti's protocols.", author: "Divya L." } },
      { id: "skin-6", combined: img16, testimonial: { quote: "People say I look 5 years younger.", author: "Anjali P." } },
      { id: "skin-7", combined: img17, testimonial: { quote: "Best dermatological care in Hyderabad.", author: "Rohit M." } },
      { id: "skin-8", combined: img18, testimonial: { quote: "The dark circles under my eyes are gone.", author: "Lakshmi V." } },
      { id: "skin-9", combined: img19, testimonial: { quote: "My skin feels much tighter and rejuvenated.", author: "Sunita K." } },
      { id: "skin-10", combined: img20, testimonial: { quote: "Transformed my skin health entirely. Thank you H-Cura.", author: "Ravi S." } },
    ],
  };

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = "";
  };

  return (
    <div className="pondyhcura-hcura-chennai">
      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <video autoPlay muted loop playsInline style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -2 }}>
         <source src={hcuraHeroVideo} type="video/mp4" />
        </video>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))', zIndex: -1 }}></div>
        <div className="tambaram-hcura-hero-content-wrapper">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="tambaram-hcura-primary-title">
            H-Cura Multispeciality Clinic in Gachibowli, Hyderabad
          </motion.h1>
          <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="tambaram-hcura-secondary-title">
            Advanced Clinical Excellence for Hair, Skin, Dental & Homeopathy
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }} className="tambaram-hcura-description-text">
            H-Cura Multispeciality Clinic is a premier healthcare destination located in the heart of Hyderabad's financial district, Gachibowli. Our facility offers a unique integration of advanced clinical dermatology, pioneering trichology, digital dentistry, and holistic homeopathic therapeutics. We are committed to providing evidence-based medical solutions that are personalized to each patient's unique health profile. Serving the communities of HITECH City, Kondapur, and Madhapur, our Gachibowli center is equipped with the latest medical technology and staffed by expert specialists dedicated to delivering visible results and sustainable wellness. Whether you are seeking restorative hair therapies, aesthetic skin transformations, or comprehensive dental care, H-Cura Gachibowli represents the pinnacle of modern Multispeciality healthcare in Hyderabad.
          </motion.p>
          <motion.div className="tambaram-hcura-action-buttons" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
            <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Consultation</Link>
            <a href="https://wa.me/918791540909" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Clinical WhatsApp
            </a>
          </motion.div>
        </div>
      </section>

      <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Clinical Case Studies – H-Cura Gachibowli</span>
          <h2>Visible Transformations & Results</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaArrowRight /></span></div>
          <p className="pondyhcura-section-description">
            Experience the documented success of our clinical protocols. This gallery showcases real transformations achieved at our Gachibowli facility, highlighting our expertise in hair restoration and dermatological skin clearance.
          </p>
        </div>
        <div className="pondyhcura-before-tabs">
          {["hair", "skin"].map((s, idx) => (
            <button key={s} className={`pondyhcura-ba-tab ${activeService === idx ? "active" : ""}`} onClick={() => handleServiceChange(idx)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <div className="pondyhcura-before-carousel-wrapper">
          <div className="pondyhcura-before-carousel" role="list">
            {(() => {
              const svcKey = activeService === 0 ? "hair" : "skin";
              const items = SAMPLE_GALLERY[svcKey] || [];
              return items.map((item, idx) => (
                <article key={item.id} className="pondyhcura-ba-clean-card" role="listitem">
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img src={item.combined} alt={`${item.title} at H-Cura Gachibowli`} className="pondyhcura-ba-clean-image" />
                      <div className="pondyhcura-ba-clean-title"><h4>{item.title}</h4></div>
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button className="pondyhcura-ba-clean-view-btn" onClick={() => openTambaramBaModal(svcKey, idx)}>View Case Study</button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      <section id="why-choose" className="pondyhcura-why-choose-enhanced">
        <div className="pondyhcura-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
        </div>
        <div className="pondyhcura-content-wrapper">
          <motion.div className="pondyhcura-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="pondyhcura-section-subtitle">The H-Cura Advantage</span>
            <h2>Why Choose Our Gachibowli Center?</h2>
            <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaShieldAlt /></span></div>
            <p className="pondyhcura-section-description">
              Our Gachibowli clinic is designed to provide elite Multispeciality care for Hyderabad's dynamic population. We combine clinical expertise with advanced medical infrastructure to ensure that every patient receives safe, ethical, and highly effective treatments.
            </p>
          </motion.div>
          <motion.div className="pondyhcura-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="pondyhcura-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="pondyhcura-feature-header">
                  <div className="pondyhcura-icon-container">{feature.icon}<div className="pondyhcura-icon-glow"></div></div>
                  <span className="pondyhcura-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
          <div className="pondyhcura-cta-container">
            <h3>Ready for Your Clinical Transformation?</h3>
            <p>Schedule a detailed consultation with our Gachibowli specialists and take the first step toward better health.</p>
            <Link to="/bookconsultation" className="pondyhcura-cta-button">Book Your Appointment Now</Link>
          </div>
        </div>
      </section>

      <section id="services" className="pondyhcura-services-premium-section" ref={sectionRef}>
        <div className={`pondyhcura-services-background ${isVisible ? "visible" : ""}`} style={{ backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed", opacity: isVisible ? 1 : 0 }}></div>
        <div className="pondyhcura-services-container">
          <div className={`pondyhcura-services-header ${isVisible ? "visible" : ""}`}>
            <span className="pondyhcura-services-subtitle">Clinical Specialties</span>
            <h2>Multispeciality Care in Gachibowli</h2>
            <p className="pondyhcura-services-description">Explore our wide range of clinical services tailored to your specific needs. Each department at H-Cura Gachibowli is led by experienced medical professionals.</p>
          </div>
          <div className={`pondyhcura-services-tabs ${isVisible ? "visible" : ""}`}>
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button key={service.id} className={`pondyhcura-service-tab ${isActive ? "active" : ""}`} onClick={() => handleServiceChange(index)}>
                  <span className={`pondyhcura-tab-icon bright-icon`} style={{ backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: sIcon?.bgColor, borderRadius: "12px", width: "44px", height: "44px", display: "inline-block" }}></span>
                  <span className="pondyhcura-tab-text">{service.id.charAt(0).toUpperCase() + service.id.slice(1)}</span>
                </button>
              );
            })}
          </div>
          <div className={`pondyhcura-service-content-wrapper ${isVisible ? "visible" : ""}`}>
            <div className={`pondyhcura-service-main-content ${isChanging ? "changing" : ""}`}>
              <div className="pondyhcura-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>
                <div className="pondyhcura-service-cta">
                  <Link to="/bookconsultation" className="pondyhcura-service-btn">Book Your Consultation</Link>
                </div>
              </div>
              <div className="pondyhcura-service-image-container">
                <img src={advancedServices[activeService].image} alt={advancedServices[activeService].title} className="pondyhcura-service-main-image" />
              </div>
            </div>
            <div className="pondyhcura-service-treatments">
              <h4>Advanced Clinical Interventions</h4>
              <div className="pondyhcura-treatments-slider">
                {advancedServices[activeService].treatments.map((treatment, tIndex) => {
                  const tIcon = treatmentIconMap[treatment.icon] || null;
                  return (
                    <div className="pondyhcura-treatment-card" key={tIndex}>
                      <div className="pondyhcura-treatment-image"><img src={treatment.image} alt={treatment.name} /></div>
                      <div className="pondyhcura-treatment-content">
                        <div className="pondyhcura-treatment-icon" style={{ backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: tIcon?.bgColor, width: "56px", height: "56px", borderRadius: "12px" }}></div>
                        <h5>{treatment.name}</h5>
                        <p>{treatment.description}</p>
                        <div className="pondyhcura-treatment-benefits">
                          <h6>Clinical Benefits:</h6>
                          <ul>{treatment.benefits.map((b, i) => <li key={i}><span className="pondyhcura-benefit-icon">✓</span>{b}</li>)}</ul>
                        </div>
                        <div className="pondyhcura-treatment-cta">
                          <Link className="pondyhcura-treatment-learnmore" to={serviceLearnMoreUrl(advancedServices[activeService].id)}>Know More</Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pondyhcura-stats-banner">
        <div className="pondyhcura-stat"><h3>20,000+</h3><p>Satisfied Patients</p></div>
        <div className="pondyhcura-stat"><h3>15+</h3><p>Years of Legacy</p></div>
        <div className="pondyhcura-stat"><h3>30+</h3><p>Specialist Doctors</p></div>
        <div className="pondyhcura-stat"><h3>11+</h3><p>Clinical Locations</p></div>
      </section>

      <section id="locations" className="pondyhcura-locations">
        <div className="pondyhcura-section-header">
          <h2>Our Gachibowli Center</h2>
          <p>Visit our advanced Multispeciality facility in Hyderabad</p>
        </div>
        <div className="pondyhcura-location-details">
          <div className="pondyhcura-location-card">
            <div className="pondyhcura-location-header">
              <h3>{locations.gachibowli.name} FACILITY</h3>
              <span className="pondyhcura-specialty-tag">{locations.gachibowli.specialties}</span>
            </div>
            <div className="pondyhcura-location-grid">
              <div className="pondyhcura-location-info">
                <div className="pondyhcura-info-item">
                  <FaMapMarkerAlt />
                  <div>
                    <h4>Clinical Address</h4>
                    <p>{locations.gachibowli.address}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaPhone />
                  <div>
                    <h4>Contact Number</h4>
                    <p>{locations.gachibowli.phone}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaClock />
                  <div>
                    <h4>Working Hours</h4>
                    <p>{locations.gachibowli.hours}</p>
                  </div>
                </div>
              </div>
              <div className="pondyhcura-popular-services">
                <h4>Facility Specialties</h4>
                <ul>{locations.gachibowli.popularServices.map((s, i) => <li key={i}><FaCheckCircle /> {s}</li>)}</ul>
                <a href={locations.gachibowli.mapUrl} target="_blank" rel="noopener noreferrer" className="pondyhcura-map-link">Get Directions <FaArrowRight /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="pondyhcura-testimonials">
        <div className="pondyhcura-section-header">
          <h2>Patient Success Stories</h2>
          <p>Read about the experiences of patients who have received clinical care at our Gachibowli center:</p>
        </div>
        <div className="pondyhcura-testimonials-grid">
          {testimonials.map((t, index) => (
            <motion.div className="pondyhcura-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <div className="pondyhcura-testimonial-rating">{[...Array(5)].map((_, i) => <FaStar key={i} className="pondyhcura-star-filled" />)}</div>
              <p className="pondyhcura-testimonial-text">"{t.text}"</p>
              <div className="pondyhcura-testimonial-author">
                <h4>{t.name}</h4>
                <p>{t.location} • {t.service}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="appointment" className="pondyhcura-appointment" style={{ position: "relative", overflow: "hidden", color: "#fff" }}>
        <video autoPlay muted loop playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -2 }}><source src={hcuraHeroVideo2} type="video/mp4" /></video>
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))", zIndex: -1 }}></div>
        <div className="pondyhcura-appointment-content">
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>Register for Consultation at Gachibowli</motion.h2>
          <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>Initialize your clinical journey toward health and restoration. Our Gachibowli specialists are ready to provide expert guidance.</motion.p>
          <div className="pondyhcura-contact-options">
            <div className="pondyhcura-contact-option"><FaPhone /> <span>+91 87915 40909</span></div>
            <div className="pondyhcura-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">h-cura.com</a></div>
          </div>
          <div className="pondyhcura-appointment-buttons">
            <Link to="/bookconsultation" className="pondyhcura-primary-button">Book Appointment</Link>
            <a href="https://wa.me/919187915409" className="pondyhcura-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Support</a>
          </div>
        </div>
      </section>

      {valasaravakamchennaiBaModalOpen && (
        <div className="pondyhcura-ba-modal" role="dialog" aria-modal="true">
          <div className="pondyhcura-ba-modal-backdrop" onClick={closeTambaramBaModal} />
          <div className="pondyhcura-ba-modal-panel">
            <header className="pondyhcura-ba-modal-header">
              <h3>Clinical Transformation - H-Cura Gachibowli</h3>
              <button className="pondyhcura-ba-modal-close" onClick={closeTambaramBaModal}>×</button>
            </header>
            <div className="pondyhcura-ba-modal-body">
              <div className="pondyhcura-ba-scrollable-container">
                <div className="pondyhcura-ba-scroll-track" id="scrollTrack">
                  <div className="pondyhcura-ba-scrollable-grid" id="scrollableGrid">
                    {valasaravakamchennaiBaModalItems.map((item, index) => (
                      <div key={item.id} className="pondyhcura-ba-scrollable-card">
                        <div className="pondyhcura-ba-scrollable-image-container"><img src={item.combined} alt={item.title} className="pondyhcura-ba-scrollable-image" /></div>
                        <div className="pondyhcura-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="pondyhcura-ba-scrollable-testimonial">"{item.testimonial?.quote || ""}"</p>
                          <div className="pondyhcura-ba-scrollable-author">— {item.testimonial?.author || ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="pondyhcura-ba-scroll-progress"><div className="pondyhcura-ba-progress-bar" id="progressBar"></div></div>
              </div>
              <div className="pondyhcura-ba-enhanced-controls">
                <div className="pondyhcura-ba-nav-buttons">
                  <button className="pondyhcura-ba-nav-btn" id="prevBtn" onClick={() => scrollGallery("prev")}>Previous Case</button>
                  <button className="pondyhcura-ba-nav-btn" id="nextBtn" onClick={() => scrollGallery("next")}>Next Case</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gachibowli;
